import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Divider from "@mui/material/Divider";
import { createTheme, ThemeProvider } from "@mui/material/styles";
const theme = createTheme();

theme.typography.body1 = {
  fontSize: "17px",
  "@media (min-width:600px)": {
    fontSize: "19px",
  },
  [theme.breakpoints.up("md")]: {
    padding: "0px 39px !important",
    fontSize: "20px",
  },
};
theme.typography.h3 = {
  fontSize: "28px",
  "@media (min-width:600px)": {
    fontSize: "30px",
  }
};

const About = () => {
  return (
    <Box id="about">
      <ThemeProvider theme={theme}>
        <Typography
          gutterBottom
          variant="h3"
          component="div"
          sx={{ textAlign: "center", pt: 7}}
        >
          ABOUT
          <Divider variant="middle" />

        </Typography>
        <Typography
          variant="body1"
          // sx={{
          //   textAlign: "center",
          // }}
        >
          I’m a Software Engineering student. Now, I'm working on
          MERN stack Development(MERN Stack). I’m very passionate and dedicated to my work. I
          have acquired the skills and necessary web app knowledge
          including Frontend , Backend and Database using JavaScript or It's
          related frameworks, runtimes and databases. Please leave a message to
          discuss your project, Let’s make something special.
        </Typography>
        <Box>
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            mb:1 , mt:3
          }}
        >
       Education:
        </Typography>
        <Typography
          variant="body1"
          sx={{
            textAlign: "center",
            mb:2
          }}
        >
        Anhui University of Technology,China - BSc in Software Engineering (2018 -2022)
        </Typography>

        </Box>
      </ThemeProvider>
    </Box>
  );
};

export default About;
